import type { PropsCoreState } from '~/store/interfaces';

import type { FeatureEntitlement } from './interfaces';

export const selectEntitlements = ({ entitlements }: PropsCoreState) => entitlements;

export const selectResolution = ({ entitlements }: PropsCoreState) =>
  entitlements.resolution;

export const selectPlanSlug = ({ entitlements }: PropsCoreState) =>
  entitlements.resolution?.planSlug ?? 'free';

export const selectPlanLabel = ({ entitlements }: PropsCoreState) =>
  entitlements.resolution?.planLabel ?? 'Free';

export const selectSubscription = ({ entitlements }: PropsCoreState) =>
  entitlements.resolution?.subscription ?? null;

export const selectEntitlementsLoading = ({ entitlements }: PropsCoreState) =>
  entitlements.loading;

const LOCKED_FALLBACK: FeatureEntitlement = {
  state: 'locked',
  source: 'plan',
  expiresAt: null,
  quotaPerMonth: null,
  quotaUsed: null,
  quotaRemaining: null,
  upgradeRequired: null,
};

export const makeSelectFeature = (slug: string) =>
  ({ entitlements }: PropsCoreState): FeatureEntitlement =>
    entitlements.resolution?.features[slug] ?? LOCKED_FALLBACK;

export const selectFlag = (slug: string) =>
  ({ entitlements }: PropsCoreState): boolean =>
    !!entitlements.resolution?.flags[slug];
